// extracted by mini-css-extract-plugin
module.exports =  {"iconContainer":"b5uBGfdVfKhEvO_hu19S","icon":"Cx3RL2A6e2YwXPl58KdS"};